export default __webpack_public_path__ + "static/media/ArrowRight.83618526.svg";